import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/ui/tooltip";

import { Input } from "@/shadcn/ui/input";
import Link from "next/link";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { trackEvent } from "@/analytics";

export default function AddMeToTheGuestList({
  comedianShortName,
  comedianId,
  followComedian,
  setFollowComedian,
}: {
  comedianShortName: string;
  comedianId: string;
  followComedian: boolean;
  setFollowComedian: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <div className="flex items-center justify-between w-full max-w-md mt-3 text-base text-gray-500">
      <span className="flex gap-x-1">
        Join {comedianShortName}&apos;s guest list
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <QuestionMarkCircleIcon
                className="w-6 h-6 text-gray-500 cursor-help"
                aria-hidden="true"
              />
            </TooltipTrigger>
            <TooltipContent sideOffset={5} className="w-[375px]">
              <p>
                Join for exclusive updates, first dibs on specials, and local
                tour dates. We only send you the good stuff, no spam! You can
                always unsubscribe from {comedianShortName}&apos;s guest list
                from your{" "}
                <Link
                  href="/profile"
                  className="text-blue-600 underline hover:text-blue-600 font-small"
                >
                  Punchup Account page
                </Link>
                .
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </span>
      <Input
        type="checkbox"
        checked={followComedian}
        className="cursor-pointer w-7"
        onChange={(e) => {
          if (e.target.checked) {
            trackEvent(
              "Checked box to follow comedian",
              { ComedianId: comedianId },
              { send_immediately: true }
            );
            setFollowComedian(true);
          } else {
            trackEvent(
              "Unchecked box to follow comedian",
              { ComedianId: comedianId },
              { send_immediately: true }
            );
            setFollowComedian(false);
          }
        }}
      />
    </div>
  );
}
